import { Badge } from "@shared/ui/badge";
import { PAGE_SIZE } from "@shared/utils/constants";
import React, { useState } from "react";
import { GenericTable } from "../../../../../shared/components/GenericTable";
import { Card, CardContent } from "../../../../../shared/ui/card";
import { usePlansList } from "../../hooks";

export const PlansListContent: React.FC = () => {
  const { data: planList } = usePlansList();
  const planListColumns = [
    {
      key: "planName",
      header: "Plan Name",
      render: (value: any, row: any) => {
        return <span className="font-medium">{row.planName}</span>;
      },
    },
    {
      key: "category",
      header: "Consumer Categories",
    },
    {
      key: "billingFrequency",
      header: "Billing Frequency",
    },
    {
      key: "validity",
      header: "Validity",
    },
    {
      key: "utilityService",
      header: "Utility Services",
      render: (value: any, row: any) => {
        return <div>{row.utilityService?.join(", ") ?? "NA"}</div>;
      },
    },
    {
      key: "statusDisplay",
      header: "Status",
      render: (value: any, row: any) => {
        return (
          <Badge className="bg-blue-100 text-blue-800">
            {row.statusDisplay}
          </Badge>
        );
      },
    },
  ];

  const [planListCurrentPage, setPlanListCurrentPage] = useState(1);

  return (
    <>
      {
        <Card>
          <CardContent className="p-0">
            <GenericTable
              data={planList?.result ?? []}
              columns={planListColumns}
              rowKey="id"
              emptyMessage="No plans found"
              loading={false}
              pagination={{
                currentPage: planListCurrentPage,
                totalPages: Math.ceil((planList?.count || 0) / PAGE_SIZE),
                totalItems: planList?.count || 0,
                itemsPerPage: PAGE_SIZE,
                startItem: (planListCurrentPage - 1) * PAGE_SIZE + 1,
                endItem: Math.min(
                  planListCurrentPage * PAGE_SIZE,
                  planList?.count || 0
                ),
              }}
              onPageChange={setPlanListCurrentPage}
            />
          </CardContent>
        </Card>
      }
    </>
  );
};
